import { all, put } from 'redux-saga/effects'
import { usersMe, getOfferedCampaigns } from 'Redux/actions/influencerActions'

function* onGetInfluencer() {
  yield all([put.resolve(usersMe()), put.resolve(getOfferedCampaigns())])
}
export default onGetInfluencer
